import { DateTime } from 'luxon';

export enum timeFormat {
  // 50 mins
  minutes,
  // 8:30pm
  simple
}

export const formatTimeForDelivery = ((time?: number, leadTime?: number, timezone?:string, format: timeFormat = timeFormat.minutes) => {
  if (!time) return;

  if (format === timeFormat.minutes) {
    return Math.round(DateTime.fromMillis(time).setZone(timezone).plus({ minutes: leadTime }).diffNow().as('minutes'));
  }

  if (format === timeFormat.simple) {
    return DateTime.fromMillis(time).setZone(timezone).plus({ minutes: leadTime }).toLocaleString(DateTime.TIME_SIMPLE);
  }
});
